import { cx } from '@7f-ui'
import { render } from 'storyblok-rich-text-react-renderer'
import type { Link } from 'storyblok-schema'

import { storyblokLink } from '../link'
import styles from './rich-text.module.css'

type Props = {
  text: unknown
  className?: string
}

export function RichText({ text, className }: Props) {
  return (
    <div className={cx(styles.richtext, '**:!text-inherit font-body-copy', className)}>
      {render(text, {
        markResolvers: {
          link: (children, props) => (
            <a
              {...storyblokLink({
                ...props,
                cached_url: props.href || '',
                // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- renderer link props are untyped strings
                linktype: props.linktype as Link['linktype'],
                // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- renderer link props are untyped strings
                target: props.target as '_blank',
              })}
            >
              {children}
            </a>
          ),
        },
      })}
    </div>
  )
}
